var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnion = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 8 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#737C92",
  d: "M6.85 7.579a.625.625 0 0 1 .884.884L4.577 11.62l-.066.06a.875.875 0 0 1-1.105 0l-.066-.06L.183 8.463a.626.626 0 0 1 .885-.884l2.89 2.892zM3.406.196a.875.875 0 0 1 1.105 0l.066.06 3.157 3.157a.625.625 0 0 1-.884.884L3.958 1.405l-2.89 2.892a.626.626 0 0 1-.885-.884L3.34.256z"
})));
export default SvgUnion;